/* eslint jsx-a11y/label-has-associated-control: 0, jsx-a11y/label-has-for: 0 */
import React, { useState, useEffect, useRef } from 'react'
import Grid from 'grid'
import { withContext } from 'ddiForm'
import { is, formatNumber, getIn, emptyList } from 'utils'
import { Fab, Menu, MenuItem, Icon } from '@material-ui/core'
import { moveProductToDifferentGroup } from 'pages/SalesOrder/actions'

import DeleteCell from './DeleteItemGroupCell'

const ITEM_HEIGHT = 48

const getRowNodeId = data => data.lineNumber

const getColumnDefs = ({ form, dispatch }) => {
  const colDefs = [
    {
      field: 'lineNumber',
      headerName: 'Ln',
      checkboxSelection: true,
      headerCheckboxSelection: true,
      filter: 'agNumberColumnFilter',
      filterParams: {
        clearButton: true,
        inRangeInclusive: true,
        suppressAndOrCondition: true
      }
    },
    {
      field: 'dataId',
      headerName: 'Product',
      filter: 'agTextColumnFilter'
    },
    {
      field: 'description',
      headerName: 'Description',
      filter: 'agTextColumnFilter'
    },
    {
      cellStyle: { 'text-align': 'right' },
      headerClass: 'align-right',
      field: 'netPrice',
      headerName: 'Net Price',
      suppressFilter: true,
      suppressMenu: true,
      valueFormatter: params => formatNumber(params.value, '0,0.0000')
    },
    {
      cellStyle: { 'text-align': 'right' },
      field: 'quantityOrdered',
      headerName: 'Qty',
      suppressMenu: true
    },
    {
      headerName: '',
      cellRendererFramework: DeleteCell,
      cellRendererParams: {
        form,
        dispatch,
        type: 'product'
      },
      maxWidth: 50,
      suppressMenu: true
    }
  ]

  return colDefs
}

export const ProductsInGroup = ({
  selectedRowIndex,
  itemGroupsMap,
  form,
  dispatch
}) => {
  const itemGroups = itemGroupsMap?.toJS ? itemGroupsMap.toJS() : []
  const menuOptions =
    itemGroups && is.array(itemGroups) && itemGroups.length
      ? itemGroups.filter(
          (x, i) => x.rowId !== 'blankrow' && i !== selectedRowIndex
        )
      : []

  const gridApi = useRef(null)

  const [rowData, setRowData] = useState([])
  const [title, setTitle] = useState('')
  const [
    selectedProductsLineNumbers,
    setSelectedProductsLineNumbers
  ] = useState([])
  const [anchorEl, setAnchorEl] = useState(null)

  const open = Boolean(anchorEl)

  useEffect(() => {
    if (
      itemGroups.length &&
      itemGroups[selectedRowIndex] &&
      itemGroups[selectedRowIndex].lineItems
    ) {
      const selectedProduct = itemGroups[selectedRowIndex]
      const newTitle = selectedProduct.dataId ? selectedProduct.dataId : ''

      setRowData(selectedProduct.lineItems)
      setTitle(newTitle)
    }
  }, [itemGroupsMap, selectedRowIndex])

  useEffect(() => {
    if (selectedRowIndex === null) {
      setRowData([])
      setTitle('')
    }
  }, [selectedRowIndex])

  const onGridReady = params => {
    if (params && params.api) {
      gridApi.current = params.api
    }
  }

  const handleClick = e => setAnchorEl(e.currentTarget)

  const handleClose = () => setAnchorEl(null)

  const handleSelectGroup = event => {
    // find better way to get dataId
    const itemGroupId = event.currentTarget.dataset.itemgroupid

    dispatch(
      moveProductToDifferentGroup.try(form, {
        itemGroupId,
        lineNumbers: selectedProductsLineNumbers
      })
    )

    setAnchorEl(null)
  }

  const onSelectionChanged = params => {
    if (params && params.api) {
      const selected = params.api.getSelectedRows().reduce((acc, next) => {
        acc = acc.concat([next.lineNumber])
        return acc
      }, [])

      setSelectedProductsLineNumbers(selected)
    }
  }

  const postProcessPopup = params => {
    if (params && params.type !== 'columnMenu') {
      return
    }

    const { ePopup } = params
    ePopup.style.zIndex = 1300
  }

  return (
    <div>
      <div style={{ flex: 1, display: 'flex' }}>
        <label style={{ marginTop: 5 }}>Move Product to Group: </label>
        <Fab
          aria-label="add group"
          aria-controls="long-menu"
          aria-haspopup="true"
          onClick={handleClick}
          // disabled when no item groups or there are no selected products
          disabled={!menuOptions.length || !selectedProductsLineNumbers.length}
          style={{
            marginBottom: '5px',
            marginLeft: '5px'
          }}
          size="small"
          color="primary"
        >
          <Icon style={{ transform: 'rotate(90deg)' }}>reply</Icon>
        </Fab>

        {/* ITEM GROUP OPTIONS */}
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          keepMounted
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: 200
            }
          }}
        >
          {menuOptions.map(option => (
            <MenuItem
              key={option.dataId}
              onClick={handleSelectGroup}
              data-itemgroupid={option.dataId}
            >
              {option.dataId}
            </MenuItem>
          ))}
        </Menu>
      </div>
      <Grid
        title={`Group ${title} Products`}
        getRowNodeId={getRowNodeId}
        columnDefs={getColumnDefs({
          form,
          dispatch
        })}
        fullWidth
        rowData={rowData}
        height={350}
        // height="50%"
        rowSelection="multiple"
        headerStyle={{
          background: '#d1d3d4',
          color: '#444',
          fontSize: 13,
          fontWeight: 400,
          lineHeight: '17px',
          margin: 0,
          padding: '5px 0',
          textAlign: 'center',
          width: '100%'
        }}
        onSelectionChanged={onSelectionChanged}
        suppressRowClickSelection
        postProcessPopup={postProcessPopup}
        onGridReady={onGridReady}
      />
    </div>
  )
}

// export const contextObj = {
//   itemGroups: form => form?.fields?.groups?.itemGroups?.rowData || [],
//   menuOptions: form => {
//     const selectedRowIndex =
//       form?.fields?.groups?.itemGroups?.selectedRowIndex ?? 0
//     const rowData = form?.fields?.groups?.itemGroups?.rowData || []

//     const result =
//       is.array(rowData) && rowData.length
//         ? rowData.filter(
//             (x, i) => x.rowId !== 'blankrow' && i !== selectedRowIndex
//           )
//         : []

//     return result
//   },
//   selectedRowIndex: form =>
//     form?.fields?.groups?.itemGroups?.selectedRowIndex ?? null
// }

/* fixed SVE 9/23/2020 */
export const contextObj = {
  itemGroupsMap: form =>
    getIn(form, 'fields.groups.itemGroups.rowData') || emptyList,
  selectedRowIndex: form => {
    const selectedRowIndex = getIn(
      form,
      'fields.groups.itemGroups.selectedRowIndex'
    )

    if (is.number(selectedRowIndex)) {
      return selectedRowIndex
    }

    return null
  }
}

export default withContext(contextObj)(ProductsInGroup)
